// Types
import { type PopoverChildrenProps, PopoverContainer } from '@/components/base/Popover';

type DatepickerPanelProps = Omit<PopoverChildrenProps, 'setReferenceElement' | 'update'> & {
    className?: string;
    children: React.ReactNode;
};

export function DatepickerPanel({
    attributes,
    children,
    className,
    open,
    setPopperElement,
    styles
}: DatepickerPanelProps) {
    return (
        <PopoverContainer
            open={open}
            styles={styles}
            width="w-[300px]"
            className={className}
            attributes={attributes}
            setPopperElement={setPopperElement}>
            {children}
        </PopoverContainer>
    );
}
